function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: bg;\n  flex: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from '@xstyled/styled-components';
import { WebsiteHeader } from './WebsiteHeader';
import { ProjectHeader } from './ProjectHeader';
import { Head } from './Head';
var Headers = styled.div(_templateObject());
var PageWrapper = styled.box(_templateObject2());
var Container = styled.div(_templateObject3());
export function BaseLayout(_ref) {
  var children = _ref.children,
      pageContext = _ref.pageContext,
      backgroundColor = _ref.backgroundColor;
  return React.createElement(Container, null, React.createElement(Head, {
    pageContext: pageContext
  }), React.createElement(Headers, null, React.createElement(WebsiteHeader, null), React.createElement(ProjectHeader, null)), React.createElement(PageWrapper, {
    backgroundColor: backgroundColor
  }, children));
}